import React from 'react';
import { useQuery, useApolloClient } from '@apollo/client';

import { GET_ERROR } from '@betwixt/common/graphql/error.js';

import Modal from '@betwixt/common/components/Modal.js';
import { ResetError } from '@betwixt/common';

const Error = () => {
  const { data } = useQuery(GET_ERROR);
  const client = useApolloClient();
  const ErrorData = data?.Error;

  if (ErrorData && ErrorData.thisWrong && ErrorData.type === 'inMODAL') {
    return (
      <Modal
        title={ErrorData.title}
        body={ErrorData.content}
        className={`ERROR ${ErrorData.type}`}
        callback={() => ResetError(client)}
      />
    );
  }

  return null;
};

export default Error;
